import React from 'react';
import UserLayout from '../components/UserLayout';
import PromotionStatus from '../components/PromotionStatus';

const PromotionStatusPage = () => (
  <UserLayout>
    <PromotionStatus />
  </UserLayout>
);

export default PromotionStatusPage;
